(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/start-page/assets/javascripts/start-page_desktop.js') >= 0) return;  svs.modules.push('/modules/start-page/assets/javascripts/start-page_desktop.js'); 
(function(svs) {
  'use strict';

  svs.modules = svs.modules || {};

  function setUpListeners() {
    var mainContent = $('#main-content');
    $(mainContent).on('click', '.js-cookie-info', showAboutCookies);
    if (svs.core.detect.feature('ft-gamelinks-analytics')) {
      $(mainContent).on('click', '.game-link-start-page-item', trackClick);
    }
  }

  function trackClick(e) {
    e.preventDefault();

    var productName = $(this)
        .find('[itemprop=name]')
        .text(),
      productUrl = $(this).attr('href'),
      evt = { category: 'Navigation', action: 'Game Chooser', opt_label: productName };
    svs.components.analytics.trackEvent(evt, function() {
      location.href = productUrl;
    });
  }

  function showAboutCookies(e) {
    e.preventDefault();
    var cookieView = svs.start_page.templates.cookie_info();
    svs.components.Modal.show(cookieView, {}, { title: 'OM COOKIES', leftButton: 'Stäng', rightButton: { visible: false } });
  }
  setUpListeners();
})(svs);

 })(window);